import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="48"
      height="48"
      viewBox="0 0 129 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9153 128C13.531 128 16.1466 128 18.7611 128C48.9217 128 79.0812 128 109.241 128C111.857 128 114.472 128 117.087 128C118.592 128 120.097 128 121.601 128C122.106 128.001 122.593 127.944 123.083 127.827C123.32 127.77 123.55 127.701 123.779 127.618C124.699 127.284 125.451 126.805 126.141 126.11C126.238 126.013 126.332 125.912 126.422 125.809C126.85 125.318 127.186 124.793 127.45 124.199C127.458 124.182 127.464 124.165 127.472 124.148C127.604 123.843 127.711 123.533 127.795 123.212C127.797 123.203 127.799 123.195 127.801 123.186C127.936 122.662 128.001 122.141 128.001 121.6C128.001 117.334 128.001 113.067 128.001 108.8C128.001 74.6667 128.001 40.5335 128.001 6.40031C128.001 2.86575 125.136 0.000610352 121.601 0.000610352C120.097 0.000610352 118.592 0.000610352 117.087 0.000610352C115.872 0.000610352 114.657 0.000610352 113.442 0.000610352C113.407 0.000610352 113.374 0.000610352 113.34 0.000610352C113.29 0.000610352 113.24 0.000610352 113.191 0.000610352C111.874 0.000610352 110.558 0.000610352 109.241 0.000610352C79.0807 0.000610352 48.9211 0.000610352 18.7605 0.000610352C17.4442 0.000610352 16.1274 0.000610352 14.8105 0.000610352C14.7608 0.000610352 14.7112 0.000610352 14.6615 0.000610352C14.6271 0.000610352 14.5937 0.000610352 14.5598 0.000610352C13.3446 0.000610352 12.1293 0.000610352 10.9141 0.000610352C9.40928 0.000610352 7.90457 0.000610352 6.40032 0.000610352C2.86519 0.000610352 0 2.86631 0 6.40031C0 40.5341 0 74.6672 0 108.8C0 113.067 0 117.334 0 121.6C0 125.135 2.86519 128 6.40032 128C7.90569 128 9.41052 128 10.9153 128Z"
        fill="#E3E3E3"
      />
      <path
        opacity="0.2"
        d="M19.6017 0C19.3217 0 19.0417 0 18.7617 0C17.4455 0 16.1286 0 14.8123 0C14.7626 0 14.7124 0 14.6628 0C14.6289 0 14.5951 0 14.5612 0C13.3459 0 12.1307 0 10.916 0C9.41119 0 7.90635 0 6.40154 0C2.86641 0 0.0012207 2.8657 0.0012207 6.3997C0.0012207 40.5334 0.0012207 74.6666 0.0012207 108.8C0.0012207 113.066 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.86641 127.999 6.40154 127.999C7.90635 127.999 9.41119 127.999 10.916 127.999C13.5311 127.999 16.1467 127.999 18.7612 127.999C19.0412 127.999 19.3211 127.999 19.6011 127.999V0H19.6017Z"
        fill="url(#paint0_linear_6151_23226)"
      />
      <path
        opacity="0.2"
        d="M108.402 0C108.682 0 108.961 0 109.241 0C110.558 0 111.875 0 113.191 0C113.241 0 113.291 0 113.34 0C113.375 0 113.408 0 113.442 0C114.658 0 115.873 0 117.088 0C118.592 0 120.097 0 121.602 0C125.137 0 128.002 2.8657 128.002 6.3997C128.002 40.5334 128.002 74.6666 128.002 108.8C128.002 113.066 128.002 117.333 128.002 121.6C128.002 125.134 125.137 127.999 121.602 127.999C120.097 127.999 118.592 127.999 117.088 127.999C114.472 127.999 111.857 127.999 109.242 127.999C108.962 127.999 108.682 127.999 108.402 127.999V0H108.402Z"
        fill="url(#paint1_linear_6151_23226)"
      />
      <path
        d="M19.6016 108.08C19.6016 78.6933 19.6016 49.3066 19.6016 19.9198C19.5999 19.6929 19.6941 19.5981 19.921 19.5998C49.3078 19.5998 78.6945 19.5998 108.081 19.5998C108.308 19.5986 108.403 19.6923 108.401 19.9198C108.401 49.3066 108.401 78.6933 108.401 108.08C108.403 108.308 108.308 108.402 108.081 108.4C78.6945 108.4 49.3078 108.4 19.921 108.4C19.6941 108.402 19.5999 108.308 19.6016 108.08Z"
        fill="#575756"
      />
      <path
        d="M108.002 107.68C108.002 78.5596 108.002 49.4398 108.002 20.3201C108.002 20.0937 107.908 20 107.682 20C78.5612 20 49.4415 20 20.3217 20C20.0953 20 20.0017 20.0937 20.0017 20.3201C20.0017 49.4398 20.0017 78.5602 20.0017 107.68C20.0017 107.906 20.0953 108 20.3217 108C49.442 108 78.5618 108 107.682 108C107.908 108 108.002 107.906 108.002 107.68Z"
        fill="#E3E3E3"
      />
      <path
        d="M63.9998 70.8019C67.7563 70.8019 70.8014 67.7567 70.8014 64.0003C70.8014 60.2439 67.7563 57.1987 63.9998 57.1987C60.2434 57.1987 57.1982 60.2439 57.1982 64.0003C57.1982 67.7567 60.2434 70.8019 63.9998 70.8019Z"
        fill="#575756"
      />
      <path
        d="M64.0003 70.4016C67.5357 70.4016 70.4017 67.5356 70.4017 64.0003C70.4017 60.4649 67.5357 57.5989 64.0003 57.5989C60.4649 57.5989 57.5989 60.4649 57.5989 64.0003C57.5989 67.5356 60.4649 70.4016 64.0003 70.4016Z"
        fill="#E3E3E3"
      />
      <path
        d="M63.5361 75.9519C70.1172 75.9519 75.4521 70.6169 75.4521 64.0359C75.4521 57.4549 70.1172 52.1201 63.5361 52.1201C56.9551 52.1201 51.6201 57.4549 51.6201 64.0359C51.6201 70.6169 56.9551 75.9519 63.5361 75.9519Z"
        fill="#575756"
      />
      <path
        d="M63.535 70.6951C67.2126 70.6951 70.194 67.7136 70.194 64.0359C70.194 60.3582 67.2126 57.377 63.535 57.377C59.8573 57.377 56.876 60.3582 56.876 64.0359C56.876 67.7136 59.8573 70.6951 63.535 70.6951Z"
        fill="#3C3C3B"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6151_23226"
          x1="16.5601"
          y1="64.0001"
          x2="0.309183"
          y2="64.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6151_23226"
          x1="111.444"
          y1="63.9998"
          x2="127.694"
          y2="63.9998"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
